<template>
  <div>
    <div class="timer">
      <span class="base-timer__label">{{ formattedTimeLeft }}</span>
      <v-btn color="primary" @click="resetTimer"> Przedłuż sesję </v-btn>
    </div>

    <!-- Dialog ostrzeżenia o sesji -->
    <v-dialog
      v-model="showWarningSnackbar"
      persistent
      max-width="500"
    >
      <v-card>
        <v-card-title class="headline">
          Kończy się czas sesji
        </v-card-title>
        
        <v-card-text class="text-center">
          <div class="d-inline-flex align-center mb-3">
            <span class="text-h6 mr-1">Sesja wygaśnie za:</span>
            <span class="font-weight-bold">{{ formattedTimeLeft }}</span>
          </div>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            color="blue"
            @click="dismissSession()"
          >
            Anuluj
          </v-btn>
          <v-btn
            color="primary"
            depressed
            @click="extendSession()"
          >
            Przedłuż sesję
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import Vue from "vue";

export default {
  data() {
    return {
      timer: 0,
      timePassed: 0,
      timerInterval: null,
      expiryDate: null,
      showWarningSnackbar: false,
      warningThreshold: 300, // 5 minut w sekundach
      warningDismissed: false,
      isExtendingSession: false
    };
  },

  computed: {
    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const hours = Math.floor(timeLeft / (60 * 60));
      let minutes = Math.floor((timeLeft % (60 * 60)) / 60);
      let seconds = timeLeft % 60;
      if (minutes < 10 && minutes >= 0) {
        minutes = `0${minutes}`;
      }
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${hours}:${minutes}:${seconds}`;
    },

    timeLeft() {
      return this.timer - this.timePassed;
    },
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
      } else {
        const shouldShow = newValue <= this.warningThreshold && !this.warningDismissed && !this.isExtendingSession;
        if (shouldShow !== this.showWarningSnackbar) {
          this.showWarningSnackbar = shouldShow;
        }
      }
    }
  },

  mounted() {
    this.refreshTimer();
    this.startTimer();
  },

  methods: {

    refreshTimer() {
      this.timer = parseInt(sessionStorage["expiration"]);
      this.expiryDate = new Date();
      this.expiryDate.setSeconds(this.expiryDate.getSeconds() + this.timer);
      this.timePassed = 0;
    },

    async resetTimer() {
      this.isExtendingSession = true;
      Vue.prototype.$keycloak.keycloak.updateToken(-1).then(refreshed => {
        if (refreshed) {
          sessionStorage["access_token"] = Vue.prototype.$keycloak.token;
          sessionStorage["expiration"] = Vue.prototype.$keycloak.tokenParsed.exp + Vue.prototype.$keycloak.timeSkew - new Date().getTime() / 1000;
          this.refreshTimer();
          this.warningDismissed = false;
        }
        setTimeout(() => {
          this.isExtendingSession = false;
        }, 500);
      });
    },
    onTimesUp() {
      clearInterval(this.timerInterval);
      this.$messagesBus.$emit("error", "Nastąpiło automatyczne wylogowanie");
      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("role");
      Vue.prototype.$keycloak.keycloak.logout({ redirectUri: process.env.VUE_APP_APP_URL });
    },

    startTimer() {
      this.timerInterval = setInterval(() => {
        let currentDate = new Date();
        if (currentDate >= this.expiryDate) {
          this.onTimesUp();
        } else {
          // Synchronizuj timePassed z rzeczywistym czasem który upłynął
          const timeElapsed = Math.floor((currentDate - (this.expiryDate.getTime() - this.timer * 1000)) / 1000);
          this.timePassed = Math.max(0, timeElapsed);
        }
      }, 1000);
    },

    // Metody wywoływane przez LoggedViewTemplate z przycisków snackbar-a
    extendSession() {
      this.showWarningSnackbar = false;
      this.resetTimer();
    },

    dismissSession() {
      this.showWarningSnackbar = false;
      this.warningDismissed = true;
    }

  }

};
</script>

<style scoped>
.timer {
  display: flex;
  align-items: center;
  margin: 0 20px;
}
.theme--dark .base-timer__label {
  color: white;
}
.base-timer__label {
  color: #0052a5;
  font-size: 14px;
}
</style>
